import Text from 'components/Text/Text';
import { UserRoles } from 'types';
import { useRoleAccess } from 'hooks/useRoleAccess';
import React from 'react';
import FirmwareField from './components/FirmwareField';
import LastSyncField from './components/LastSyncField';
import TabletAppField from './components/TabletAppField';
import UpdateHistoryControlPanel from './components/UpdateHistoryControlPanel/UpdateHistoryControlPanel';
import UpdateHistoryList from './components/UpdateHistoryList/UpdateHistoryList';
import UpdateHistoryPagination from './components/UpdateHistoryPagination/UpdateHistoryPagination';
import style from './Info.module.scss';

const Info: React.FC = () => {
	const hasAccess = useRoleAccess([UserRoles.SUPER_USER, UserRoles.TECHNICAL]);

	return (
		<div className={style.container} data-test="Info">
			<div className={style.fieldsWrapper}>
				<Text
					className={style.heading}
					translationNameSpace="form"
					translationKey="infoHeading"
					theme="secondary"
					size="l"
					weight="bold"
				/>
				{hasAccess && (
					<>
						<FirmwareField />
						<TabletAppField />
					</>
				)}
				<LastSyncField />
			</div>
			{hasAccess && (
				<div className={style.fieldsWrapper}>
					<Text
						className={style.heading}
						translationNameSpace="form"
						translationKey="updateHistoryHeading"
						theme="secondary"
						size="l"
						weight="bold"
					/>
					<UpdateHistoryControlPanel />
					<UpdateHistoryList />
					<UpdateHistoryPagination />
				</div>
			)}
		</div>
	);
};

export default Info;
